import React from "react";
import LogoLight from "../../assets/img/logo/logo-light.svg"

import "./styles.scss";

export default function FooterComponent() {
  return (
    <>
      <footer id="footer" class="site-footer">
        <div class="wrapper">
          <div id="back-to-top">
            <a class="scroll-to-id" href="#">
              <i class="malex-icon-arrow-up"></i>
            </a>
          </div>

          <div class="footer">
            <div class="d-flex flex-column flex-md-row flex-lg-row flex-xl-row justify-content-between">
              <div class="align-self-center">
                <div class="logo logo-secondary" title="Logo" href="/">
                  <img src={LogoLight} alt="Logo" />
                </div>
              </div>

              <div class="align-self-center">
                <div class="copyright">
                  <p>
                    ©{" "}
                    <script>document.write( new Date().getFullYear() );</script>{" "}
                    CodeBubble Technology PVT.
                  </p>
                </div>
              </div>

              <div class="align-self-center">
                <nav class="menu-secondary">
                  <ul class="nav">
                    <li class="nav-item">
                      <a
                        title="LinkedIn"
                        href="https://www.linkedin.com/company/codebubble-technologies-pvt-ltd/about/"
                      >
                        <i class="fab fa-linkedin-in"></i>
                      </a>
                    </li>

                    {/* <li class="nav-item">
                      <a
                        title="Facebook"
                        href="https://www.facebook.com/adveits/"
                      >
                        <i class="fab fa-facebook-f"></i>
                      </a>
                    </li> */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
